// Phase H.11 — block-level signature line node.
//
// Renders as a styled block in the editor and serializes to:
//   <div class="signature-line"><div class="sig-rule"></div><div class="sig-label">{label}</div></div>
// so the PDF renderer can style it via index.css. This is NOT a legal e-sign
// placeholder — those still flow through the existing signature pad. This is
// a layout helper for printed paper copies.

import { Node, mergeAttributes } from "@tiptap/core";

export const SignatureLineNode = Node.create({
    name: "signatureLine",
    group: "block",
    atom: true,
    selectable: true,
    draggable: false,

    addAttributes() {
        return {
            label: {
                default: "Signature",
                parseHTML: (el) => {
                    const labelEl = el.querySelector(".sig-label");
                    return labelEl ? labelEl.textContent.trim() : "Signature";
                },
            },
        };
    },

    parseHTML() {
        return [{ tag: "div.signature-line" }];
    },

    renderHTML({ node, HTMLAttributes }) {
        return [
            "div",
            mergeAttributes(HTMLAttributes, { class: "signature-line" }),
            ["div", { class: "sig-rule" }],
            ["div", { class: "sig-label" }, node.attrs.label || "Signature"],
        ];
    },

    addCommands() {
        return {
            insertSignatureLine:
                (label = "Signature") =>
                ({ commands }) =>
                    commands.insertContent({
                        type: this.name,
                        attrs: { label },
                    }),
        };
    },
});

export default SignatureLineNode;
